import React from 'react';
import { useTranslate } from '@bynder/localization';
import { IconNotifications } from '@bynder/icons';

/*
 * bynder-platform/bynder/views/navigation/topmenu.cfm: 118
 */
export function TaskFeed() {
	const { translate } = useTranslate();

	return (
		<li id="taskFeed">
			<a href="#" className="admin-dropdown" tabIndex={-1}>
				<IconNotifications />
			</a>
			<div className="activity-dropdown tasks">
				<h2>{translate('activity.yourTasks')}</h2>
				<ul className="single" id="task-list" />
			</div>
		</li>
	);
}
